import React, { useEffect, useState } from 'react'
import { Button, Image, Table } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Select from 'react-select'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'
import DeleteIcon from '../../../components/AllSvgIcon/DeleteIcon'
import EditIcon from '../../../components/AllSvgIcon/EditIcon'
import HKBadge from '../../../components/Badges'
import Loader from '../../../components/Loader'
import SearchBox from '../../../components/Searchbox'
import CustomToast from '../../../components/Toast/CustomToast'
import { customStyles } from '../../../components/customStyles'
import {
  calculatePageRange,
  encodedSearchText,
  showToast
} from '../../../lib/AllGlobalFunction'
import {
  allCrudNames,
  allPages,
  checkPageAccess
} from '../../../lib/AllPageNames'
import { pageRangeDisplayed } from '../../../lib/AllStaticVariables'
import axiosProvider from '../../../lib/AxiosProvider'
import { _brandCertificateImg_ } from '../../../lib/ImagePath'
import { _SwalDelete, _exception } from '../../../lib/exceptionMessage'
import useDebounce from '../../../lib/useDebounce'
import AssignBrandToSellerForm from './AssignBrandToSellerForm'

const AssignBrandToSellerList = () => {
  const initVal = {
    brandId: '',
    sellerID: '',
    status: '',
    brandCertificate: ''
  }
  const [searchText, setSearchText] = useState()
  const [data, setData] = useState()
  const [modalShow, setModalShow] = useState(false)
  const debounceSearchText = useDebounce(searchText, 500)
  const { pageAccess, userInfo } = useSelector((state) => state.user)
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [initialValues, setInitialValues] = useState(initVal)
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })
  const [allState, setAllState] = useImmer({
    brand: [],
    sellerDetails: []
  })
  const [filterDetails, setFilterDetails] = useImmer({
    pageSize: 50,
    pageIndex: 1,
    searchText: '',
    sellerID: ''
  })

  const handlePageClick = (event) => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setFilterDetails((draft) => {
      draft.pageIndex = event.selected + 1
    })
  }

  const handleDelete = async (id) => {
    setLoading(true)
    try {
      const response = await axiosProvider({
        method: 'DELETE',
        endpoint: `AssignBrandToSeller?id=${id}`,
        userId: userInfo?.userId,
        location: location.pathname
      })

      if (response?.status === 200) {
        fetchData()
      }
      setLoading(false)
      showToast(toast, setToast, response)
    } catch (error) {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  const fetchData = async () => {
    try {
      setLoading(true)

      const response = await axiosProvider({
        method: 'GET',
        endpoint: 'AssignBrandToSeller/search',
        queryString: `?searchText=${encodedSearchText(
          filterDetails?.searchText
        )}&pageIndex=${filterDetails?.pageIndex}&pageSize=${
          filterDetails?.pageSize
        }&sellerID=${filterDetails?.sellerID}`
      })
      setLoading(false)

      if (response?.status === 200) {
        setData(response)

        if (!allState?.sellerDetails?.length) {
          const response = await axiosProvider({
            method: 'GET',
            endpoint: 'SellerData/bindActiveSeller',
            queryString: '?pageindex=0&PageSize=0'
          })
          if (response?.status === 200) {
            setAllState((draft) => {
              draft.sellerDetails = response?.data?.data
            })
          }
        }
      }
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filterDetails])

  useEffect(() => {
    if (debounceSearchText) {
      setFilterDetails((draft) => {
        draft.searchText = debounceSearchText
        draft.pageIndex = 1
      })
    } else {
      setFilterDetails((draft) => {
        draft.searchText = ''
        draft.pageIndex = 1
      })
    }
  }, [debounceSearchText])

  return (
    <>
      <div className='d-flex align-items-center mb-3 gap-3 flex-row-reverse'>
        {checkPageAccess(
          pageAccess,
          allPages?.assignBrandToSeller,
          allCrudNames?.write
        ) && (
          <Button
            variant='warning'
            className='d-flex align-items-center gap-2 fw-semibold btn btn-warning ms-auto'
            onClick={async () => {
              setModalShow(true)
              setInitialValues(initVal)
              if (!allState?.sellerDetails?.length) {
                try {
                  const response = await axiosProvider({
                    method: 'GET',
                    endpoint: 'SellerData/bindActiveSeller',
                    queryString: '?pageindex=0&PageSize=0'
                  })

                  if (response?.status === 200) {
                    setAllState((draft) => {
                      draft.sellerDetails = response?.data?.data
                    })
                  }
                } catch {}
              }

              if (!allState?.brand?.length) {
                try {
                  const response = await axiosProvider({
                    method: 'GET',
                    endpoint: 'Brand/search',
                    queryString: `?pageindex=0&PageSize=0&status=Active`
                  })

                  if (response?.status === 200) {
                    setAllState((draft) => {
                      draft.brand = response?.data?.data
                    })
                  }
                } catch {}
              }
            }}
          >
            <i className='m-icon m-icon--plusblack'></i>
            Create
          </Button>
        )}

        <div className='page-range'>
          {calculatePageRange({
            ...filterDetails,
            recordCount: data?.data?.pagination?.recordCount ?? 0
          })}
        </div>

        <div className='d-flex align-items-center'>
          <label className='me-1'>Show</label>
          <select
            styles={customStyles}
            menuPortalTarget={document.body}
            name='dataget'
            id='parpageentries'
            className='form-select me-1'
            value={filterDetails?.pageSize}
            onChange={(e) => {
              setFilterDetails((draft) => {
                draft.pageSize = e?.target?.value
                draft.pageIndex = 1
              })
            }}
          >
            <option value='10'>10</option>
            <option value='25'>25</option>
            <option value='50'>50</option>
            <option value='100'>100</option>
            <option value='200'>200</option>
            <option value='500'>500</option>
          </select>
        </div>

        <SearchBox
          placeholderText={'Search'}
          value={searchText}
          searchclassnamewrapper={'searchbox-wrapper'}
          onChange={(e) => {
            setSearchText(e?.target?.value)
          }}
        />

        <div className='col-md-3 input-file-wrapper'>
          <Select
            name='sellerID'
            isClearable
            placeholder='Seller'
            styles={customStyles}
            menuPortalTarget={document.body}
            value={
              filterDetails?.sellerID && {
                value: filterDetails?.sellerID,
                label: filterDetails?.sellerName
              }
            }
            options={
              allState?.sellerDetails &&
              allState?.sellerDetails?.map(({ userId, displayName }) => ({
                value: userId,
                label: displayName
              }))
            }
            onChange={async (e) => {
              if (e?.value) {
                setFilterDetails((draft) => {
                  draft.pageSize = 10
                  draft.pageIndex = 1
                  draft.sellerID = e?.value
                  draft.sellerName = e?.label
                })
              } else {
                setFilterDetails((draft) => {
                  draft.pageSize = 10
                  draft.pageIndex = 1
                  draft.sellerID = ''
                  draft.sellerName = ''
                })
              }
            }}
          />
        </div>
      </div>

      <Table responsive className='align-middle table-list'>
        <thead>
          <tr>
            <th>Brand Name</th>
            <th>Seller Name</th>
            <th>Status</th>
            {checkPageAccess(pageAccess, allPages?.assignBrandToSeller, [
              allCrudNames?.update,
              allCrudNames?.delete
            ]) && <th className='text-center'>Action</th>}
          </tr>
        </thead>
        <tbody>
          {data?.data?.data?.length > 0 ? (
            data?.data?.data?.map((data, index) => (
              <tr key={data?.id}>
                <td>
                  <div>
                    <Image
                      src={
                        data?.brandCertificate
                          ? `${process.env.REACT_APP_IMG_URL}${_brandCertificateImg_}${data?.brandCertificate}`
                          : 'https://placehold.jp/50x50.png'
                      }
                      className='img-thumbnail table-img-box'
                    />
                  </div>
                  <span>{data.brandName}</span>
                </td>
                <td>{data.sellerName}</td>
                <td>
                  <HKBadge
                    badgesbgname={
                      data.status.toLowerCase() === 'active'
                        ? 'success'
                        : 'danger'
                    }
                    badgesTxtname={data.status}
                    badgeClassname={''}
                  />
                </td>
                {checkPageAccess(pageAccess, allPages?.assignBrandToSeller, [
                  allCrudNames?.update,
                  allCrudNames?.delete
                ]) && (
                  <td className='text-center'>
                    <div className='d-flex gap-2 justify-content-center'>
                      {checkPageAccess(
                        pageAccess,
                        allPages?.assignBrandToSeller,
                        allCrudNames?.update
                      ) && (
                        <span
                          onClick={() => {
                            setModalShow(!modalShow)
                            setInitialValues(data)
                          }}
                        >
                          <EditIcon bg={'bg'} />
                        </span>
                      )}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.assignBrandToSeller,
                        allCrudNames?.delete
                      ) && (
                        <span
                          onClick={() => {
                            Swal.fire({
                              title: _SwalDelete.title,
                              text: _SwalDelete.text,
                              icon: _SwalDelete.icon,
                              showCancelButton: _SwalDelete.showCancelButton,
                              confirmButtonColor:
                                _SwalDelete.confirmButtonColor,
                              cancelButtonColor: _SwalDelete.cancelButtonColor,
                              confirmButtonText: _SwalDelete.confirmButtonText,
                              cancelButtonText: _SwalDelete.cancelButtonText
                            }).then((result) => {
                              if (result.isConfirmed) {
                                handleDelete(data?.id)
                              } else if (result.isDenied) {
                              }
                            })
                          }}
                        >
                          <DeleteIcon bg={'bg'} />
                        </span>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className='text-center'>
                {data?.data?.message}
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {data?.data?.pagination?.pageCount > 0 && (
        <ReactPaginate
          className='list-inline m-cst--pagination d-flex justify-content-end gap-1'
          breakLabel='...'
          nextLabel=''
          onPageChange={handlePageClick}
          pageRangeDisplayed={pageRangeDisplayed}
          pageCount={data?.data?.pagination?.pageCount}
          previousLabel=''
          renderOnZeroPageCount={null}
          forcePage={filterDetails?.pageIndex - 1}
        />
      )}

      <AssignBrandToSellerForm
        initVal={initVal}
        initialValues={initialValues}
        modalShow={modalShow}
        setModalShow={setModalShow}
        setInitialValues={setInitialValues}
        loading={loading}
        setLoading={setLoading}
        fetchData={fetchData}
        toast={toast}
        setToast={setToast}
        allState={allState}
      />

      {loading && !modalShow && <Loader />}

      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}
    </>
  )
}

export default AssignBrandToSellerList
